module.exports = __webpack_public_path__ + "img/zhaobiao.45438405.png";